"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PendingContentBlock = void 0;
const React = require("react");
const Loader_1 = require("../../atoms/Loader");
const styles = require("./styles.scss");
const cssComposer_1 = require("../../../../helpers/cssComposer");
const css = (0, cssComposer_1.default)(styles, "PendingContentBlock");
/**
 * TODO
 */
const PendingContentBlock = ({ check, children = null, size = "", message }) => {
    return check ? (children) : (React.createElement("div", { className: css("", `-size-${size}`) },
        React.createElement("div", null,
            !!message && (React.createElement("p", null,
                React.createElement("label", null, message))),
            React.createElement(Loader_1.Loader, { size: "md" }))));
};
exports.PendingContentBlock = PendingContentBlock;
//# sourceMappingURL=index.js.map